import typeCheck from 'common/util/typeCheck';

import { INCOME_VERIFICATION_DEFAULT_PROVIDER } from 'common/incomeVerificationConstants';

import { SR_API_ACTION_EMPLOYMENT_VERIFICATION_CREATE } from 'api/actionTypes';

export default async function create({ state, apiClient }, { userId }) {
  typeCheck('userId::PositiveNumber', userId);

  const employmentVerification = await apiClient.postWithState({
    action: SR_API_ACTION_EMPLOYMENT_VERIFICATION_CREATE,
    state: state,
    payload: {
      userId,
      provider: INCOME_VERIFICATION_DEFAULT_PROVIDER,
    },
  });

  return employmentVerification;
}
